import { render, staticRenderFns } from "./DisposeDetail.vue?vue&type=template&id=5e7e143b"
import script from "./DisposeDetail.vue?vue&type=script&lang=js"
export * from "./DisposeDetail.vue?vue&type=script&lang=js"
import style0 from "./DisposeDetail.vue?vue&type=style&index=0&id=5e7e143b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports